(function ($, undefined) {
    'use strict';
    var formValidator;
    var utils;
    var participantsCtn;
    var noParticipantsActions;
    var validateParticipantsBtn;
    var addParticipantBtn;
    var changeOccured = false;
    var removing = false;
    var processingSignup = false;
    var formCtn;
    var cartUtils;
    var pageEventId;
    var hubspot;
    var participantsQuantity = 0;

    var goToNextStep = function () {
        const btn = $(this);
        const currentStep = btn.closest('.payment-step');
        const scrollingCtn = btn.attr('data-scrolling-ctn');

        if (this.tagName !== 'INPUT') {
            formValidator.validateForm(currentStep);
        } else {
            currentStep.addClass('is-checked');
        }

        if (!currentStep.hasClass('has-error')) {
            const _scroll = () => {
                const nextStep = currentStep.nextAll(':visible');
                let target = nextStep.offset().top;
                
                if (scrollingCtn === '.cart-payment-popup .stool-shared-popup-inner') {
                    target = nextStep.offset().top + $(scrollingCtn).scrollTop() - $(scrollingCtn).offset().top;
                }
                if (scrollingCtn && $(scrollingCtn).scrollTop() < target) {
                    target = target - 100;
                    $(scrollingCtn).animate({scrollTop: target}, 'slow');
                }
                //if (nextStep.find('.event-signup__confirm-order-btn')[0]) 
                    nextStep.find('.event-signup__confirm-order-btn').trigger('click');
            };
            
            if (this.tagName !== 'INPUT') {
                btn.addClass('btn_disabled btn_grey');
                _scroll();
            } else if (btn.prop('checked')) {
                btn.closest('.form-checkbox-ctn').addClass('btn_disabled');
                _scroll();
            }
        }
    };

    var enableValidateBtn = function (e) {
        const targ = $(e.target);
        if (!targ.is('.payment-step__validate-btn') && targ.closest('.payment-step__validate-btn').length === 0) {
            var stepCtn = $(this);
            stepCtn.find('.payment-step__section-actions-btns .btn_disabled').removeClass('btn_disabled btn_grey');
        }
    };

    var addParticipantInputs = function () {
        var btn = $(this);
        var cloneClass = 'event-signup__participant_clone';
        var clone = $('.' + cloneClass).clone();
        var selfSignup = btn.hasClass('event-signup__add-participant-btn_prefill');

        if (selfSignup) {
            clone.find('.lastName').val(formCtn.attr('data-lastname'));
            clone.find('.firstName').val(formCtn.attr('data-firstname'));
            clone.find('.email').val(formCtn.attr('data-email'));
            clone.find('.pmiNumber').val(formCtn.attr('data-pminumber'));
            clone.attr('data-firstname', clone.find('.firstName').val());
            clone.attr('data-lastname', clone.find('.lastName').val());
            clone.addClass('self');
        } else if (btn.hasClass('js-activate-add-participant')) {
            clone.find('.lastName').val(formCtn.attr('data-lastname'));
            clone.find('.firstName').val(formCtn.attr('data-firstname'));
            clone.find('.email').val(formCtn.attr('data-email'));
            clone.attr('data-lastname', formCtn.attr('data-lastname'));
            clone.attr('data-firstname', formCtn.attr('data-firstname'));
        }

        noParticipantsActions.fadeOut(function () {
            participantsCtn.append(clone).fadeIn();
            participantsCtn.find('.' + cloneClass).fadeIn(function () {
                $(this).removeClass(cloneClass);
            });
            btn.closest('.payment-step').removeClass('payment-step_no-actions');

            if (selfSignup) {
                signupParticipant(participantsCtn.find('.self'));
            } else {
                $('.payment-step__section-actions').find(addParticipantBtn).addClass('btn_disabled');
                validateParticipantsBtn.addClass('btn_hide');
            }
        });
    };

    var signupParticipant = function (participant) {
        var errorMsg = participant.closest('.payment-step').find('.error-occured');
        var alreadySignedErrorMsg = participant.closest('.payment-step').find('.already-signed-up');
        var alreadyInCartErrorMsg = participant.closest('.payment-step').find('.already-in-cart');

        formValidator.validateForm(participant);

        // Reset error signs
        errorMsg.slideUp();
        alreadySignedErrorMsg.slideUp();
        alreadyInCartErrorMsg.slideUp();

        if (!participant.hasClass('has-error')) {
            // Show processing
            participant.addClass('has-processing_active');

            var data = {
                eventId: formCtn.attr('data-eventid'),
                firstName: participant.find('.firstName').val(),
                lastName: participant.find('.lastName').val(),
                email: participant.find('.email').val(),
                pmiNumber: participant.find('.pmiNumber').val(),
                ajax: true,
                cart: true
            };

            // Send participant data
            $.ajax({
                url: '/action/pmiSignup',
                type: 'POST',
                cache: false,
                data: data,
                dataType: 'text',
                complete: function (response) {
                    let resp;
                    if (utils.isJson(response.responseText)) {
                        resp = JSON.parse(response.responseText);
                    }
                    if (!resp || !resp.ok) {
                        // Error
                        console.error(resp.data.error);
                        // Hide processing
                        participant.removeClass('has-processing_active');
                        participant.removeClass('signed-up');
                        participant.find('input.lastName').removeAttr('disabled');
                        participant.find('input.firstName').removeAttr('disabled');
                        addParticipantBtn.addClass('btn_disabled');
                        validateParticipantsBtn.addClass('btn_hide');
                        if (resp.data.error === 'alreadyRegistered') {
                            alreadySignedErrorMsg.slideDown();
                        } else if (resp.data.error === 'alreadyInCart') {
                            alreadyInCartErrorMsg.slideDown();
                        }
                        resetProcessingSignup();
                        return;
                    }
                    // Increase participant count
                    participantsQuantity++;
                    // Hide processing
                    participant.removeClass('has-processing_active');
                    participant.addClass('signed-up');
                    participant.find('input.lastName').attr('disabled', 'disabled');
                    participant.find('input.firstName').attr('disabled', 'disabled');
                    if (participant.find('input.email').val() === formCtn.attr('data-email') && participant.find('input.pmiNumber').val() === formCtn.attr('data-pminumber')) {
                        participant.find('input').attr('disabled', 'disabled');
                    }
                    if (participantsCtn.find('.participant:not(.signed-up)').length === 0) {
                        addParticipantBtn.removeClass('btn_disabled');
                        validateParticipantsBtn.removeClass('btn_hide');
                    }
                    updateRecap(resp);
                    //- Language > langue_du_cours > Fran�ais / Anglais
                    //- Start date of the event > date_de_l_evenement > UTC midnight aligned unix millisecond timestamps (LONG)
                    //- End date of the event > date_de_fin_de_l_evenement > UTC midnight aligned unix millisecond timestamps (LONG)
                    //- Type of event (Virtual or In Person) > en_presentiel_ou_virtuel > Pr�sentiel / Virtuel
                    //- Type of class (Private or Public) > type_de_cours > Public / Priv�
                    const event = resp.data.cart.events[0];
                    const sd = new Date(`${formCtn.attr('data-startdate')}T00:00:00.000Z`);
                    const ed = new Date(`${formCtn.attr('data-enddate')}T00:00:00.000Z`);
                    const extraDealInfo = {
                        langue_du_cours: event.eventLang === 'fr' ? 'Fran\xE7ais' : 'Anglais',
                        date_de_l_evenement: sd.getTime(),
                        date_de_fin_de_l_evenement: ed.getTime(),
                        en_presentiel_ou_virtuel: event.field4 === 'webcast' ? 'Virtuel' : 'Pr\xE9sentiel',
                        type_de_cours: ['0', '2', '3'].indexOf(event.eventType) > -1 ? 'Public' : 'Priv\xE9'
                    };
                    hubspot.createOrUpdateHubspotDeal(
						resp.data.hs_product_id,
                        participantsQuantity,
                        data.eventId,
                        extraDealInfo,
						(hubspotResponse) => {
                            resetProcessingSignup();
						}
					);
                }
            });
        }
    };

    var handleParticipant = function () {
        var input = $(this);
        var participant = input.closest('.event-signup__participant');
        var hasRequiredValues = (participant.find('.firstName').val().length > 0 && participant.find('.lastName').val().length > 0 && participant.find('.email').val().length > 0);

        if (!removing && hasRequiredValues && changeOccured) {
            formValidator.validateForm(participant);
            changeOccured = false;

            if (!participant.hasClass('has-error') && !processingSignup) {
                processingSignup = true;
                participant.find('input').filter(function () {
                    return !this.value;
                }).attr('disabled', 'disabled');

                if (!participant.hasClass('signed-up')) {
                    signupParticipant(participant);
                } else {
                    removeParticipantAjax(pageEventId, participant.attr('data-firstname'), participant.attr('data-lastname'), function () {
                        signupParticipant(participant);
                    });
                }
            }
        }
    };

    var resetProcessingSignup = function () {
        $('.event-signup__participant').find('input').filter(function () {
            return !this.value;
        }).removeAttr('disabled');
        processingSignup = false;
    };

    var removeParticipantAjax = function (eventId, firstName, lastName, callback) {
        var participant = getParticipantItem(eventId, firstName, lastName);
        var errorMsg;

        if (participant) {
            errorMsg = participant.closest('.payment-step').find('.error-occured');
            participant.addClass('has-processing_active');
        }
        if (errorMsg) {
            errorMsg.slideUp();
        }

        var data = {
            eventId: eventId,
            firstName: firstName,
            lastName: lastName,
            delete: true,
            ajax: true,
            cart: true
        };

        $.ajax({
            url: '/action/pmiSignup',
            type: 'POST',
            cache: false,
            data: data,
            dataType: 'text',
            complete: function (response) {
                var response = response.responseText;
                // console.log('remove signed up participant : ', response);

                if (utils.isJson(response) && JSON.parse(response).ok) {
                    // console.log('removed')
                    if (callback) {
                        callback(JSON.parse(response));
                    }
                } else if (errorMsg) {
                    // console.log('error while removing')
                    resetProcessingSignup();
                    errorMsg.slideDown();
                }
            }
        });
    };

    var removeParticipant = function (eventId, firstName, lastName) {
        removing = true;
        var participant = getParticipantItem(eventId, firstName, lastName, $('.event-signup[data-eventid="' + eventId + '"]').length === 0);
        var cartItem = $('.cart-popup-item[data-event-id="' + eventId + '"][data-firstname="' + firstName + '"][data-lastname="' + lastName + '"]');

        removeParticipantAjax(eventId, firstName, lastName, function (cart) {
            // Decrease participant count
            participantsQuantity--;
            // cart = json cart data passed via pmiSignup
            if (cartItem) {
                cartUtils.removeFromCartComplete(cartItem, 'success', function () {}, cart);
            }
            // Check for any signed up participants in cart
            if (participant) {
                participant.slideUp(function () {
                    $(this).remove();
                    removing = false;
                    resetSignupBtnsState();
                    updateRecap(null, false, eventId);
                });
            }
        });
    };

    var getParticipantItem = function(eventId, firstName, lastName, custom = undefined) {
        var participant;
        if (custom === undefined || custom === false) {
            participant = $('.event-signup[data-eventid="' + eventId + '"] .event-signup__participant[data-firstname="' + firstName.trim() + '"][data-lastname="' + lastName.trim() + '"]');
        } else {
            participant = $('.cart-popup-item[data-event-id="' + eventId + '"][data-firstname="' + firstName.trim() + '"][data-lastname="' + lastName.trim() + '"]');
        }
        return participant;
    };

    var resetSignupBtnsState = function () {
        if (participantsCtn.find('.event-signup__participant').length === 0) {
            participantsCtn.closest('.payment-step').addClass('payment-step_no-actions');
            $('.payment-step__section-actions').find(addParticipantBtn).addClass('btn_disabled');
            validateParticipantsBtn.addClass('btn_hide');
            participantsCtn.fadeOut(function () {
                noParticipantsActions.removeClass('event-signup__add-participant-btns_hidden').fadeIn();
            });
        }
    };

    var updatePersonsCount = function () {
        $('.cart-recap__person-value').html(participantsQuantity);

        if (participantsQuantity > 0) {
            $('.cart-recap__person').removeClass('cart-recap__person_hidden');

            if (participantsQuantity > 1) {
                $('.cart-recap__person-plural').removeClass('cart-recap__person-plural_hidden');
            } else {
                $('.cart-recap__person-plural').addClass('cart-recap__person-plural_hidden');
            }
        } else {
            $('.cart-recap__person').addClass('cart-recap__person_hidden');
        }
    };

    var updateRecap = function (cart, getCart = true, eventId = - 1) {
        // update participant count
        updatePersonsCount();
        if (cart) {
            cartUtils.verifyCartIsUpToDate(cart);
        } else if (getCart) {
            cartUtils.verifyCartIsUpToDate();
        }
        if ($('.cart-coaching-item.cart-coaching-item_added').length !== 0) {
            $('.cart-coaching-item.cart-coaching-item_added').find('.cart-coaching-item__add-to-cart-btn').trigger('click');
        } else {
            //When triggering from a different page from participan signup : we have to fetch the information from the cart
            updateCartCoachingProduct($(this), participantsQuantity, $('.cart-popup-item[data-product-id != 0][data-event-id = ' + eventId + ']'));
    	}
    };

    var submitPayment = function () {
        var btn = $(this);
        var hasParticipants = true;
        var errorMsgNoPartipant = $('.js-form-error-message.participant');

        formCtn.find('.payment-step').each(function () {
            formValidator.validateForm($(this));
        });

        if (formCtn.find('.event-signup__participant.signed-up').length === 0) {
            hasParticipants = false;
            errorMsgNoPartipant.slideDown();
            $('.payment-step_participants').addClass('has-error');
        } else {
            errorMsgNoPartipant.slideUp();
        }

        if (formCtn.find('.payment-step.has-error').length === 0 && hasParticipants) {
            formCtn.addClass('has-processing_active');
            formCtn.find('.select-state-input-ctn:not(.selected)').remove();
            formCtn.find('form').submit();
        } else {
            var target = $('.payment-step.has-error').eq(0).offset().top - 100;
            $('html, body').animate({scrollTop: target}, 500);
        }
    };

    var updateCartCoachingProduct = function (btn, qty, custom = undefined) {
        var product = (custom === undefined) ? btn.closest('.cart-coaching-item') : custom;
        var productId = (custom === undefined) ? product.attr('data-id') : product.attr('data-product-id');
        var eventId = (custom === undefined) ? product.attr('data-eventid') : product.attr('data-event-id');
        var options = {};

        product.addClass('has-processing_active');
        if (qty !== 0) {
            var id = productId;
            if ($('.cart-popup-item[data-product-id="' + productId + '"][data-event-id = "' + eventId + '"]').length > 0) {
                id = $('.cart-popup-item[data-product-id="' + productId + '"][data-event-id = "' + eventId + '"]').attr('data-cart-id');
            }
            $('.cart-popup-item[data-product-id="' + productId + '"]').remove();
            $('.cart-payment-item[data-product-id="' + productId + '"]').remove();

            cartUtils.addToCart(id, qty, function (response) {
                product.removeClass('has-processing_active');
                product.addClass('cart-coaching-item_added');
                product.closest('.event-signup__step_certification').removeClass('ignored');
            }, options, '', true, true, eventId);
        } else {
            cartUtils.removeFromCart($('.cart-popup-item[data-cart-id="' + productId + '"][data-event-id = "' + eventId + '"]'), function (response) {
                product.removeClass('has-processing_active');
            }, true);
        }
    };

    var goToPayment = function () {
        var btn = $(this);
        var hasParticipants = true;
        var errorMsgNoPartipant = $('.js-form-error-message.participant');

        formCtn.find('.payment-step').each(function () {
            formValidator.validateForm($(this));
        });

        if (formCtn.find('.event-signup__participant.signed-up').length === 0) {
            hasParticipants = false;
            errorMsgNoPartipant.slideDown();
            $('.event-signup__step_participants').addClass('has-error');
        } else {
            errorMsgNoPartipant.slideUp();
        }

        if (formCtn.find('.payment-step.has-error').length === 0 && hasParticipants) {
            $('.stool-shared-popup[data-id=' + btn.attr('data-id') + ']').addClass('visible');
        } else {
            var target = $('.payment-step.has-error').eq(0).offset().top - 100;
            $('html, body').animate({scrollTop: target}, 500);
        }
    };

    var updateParticipantNameData = function () {
        var participant = $(this).closest('.event-signup__participant');

        participant.attr('data-firstname', participant.find('.firstName').val().trim());
        participant.attr('data-lastname', participant.find('.lastName').val().trim());
    };
    
    var submitEventPromoSignupForm = function(e) {
        e.preventDefault();
        var form = e.currentTarget || this;
        var valid = formValidator.validate(form);
        
        if (valid) {
            var fields = form.elements;
            var count = 3;
            
            var _complete = function() {
                if (--count <= 0) {
                    form.submit();
                }
            };
            
            utils.saveMG2SessionVariable('eventPromoSignupFirstName', fields.firstName.value, _complete);
            utils.saveMG2SessionVariable('eventPromoSignupLastName', fields.lastName.value, _complete);
            utils.saveMG2SessionVariable('eventPromoSignupEmail', fields.email.value, _complete);
        }
    };

    $(window).ready(function () {
        utils = Fw.component.models().utils;
        formValidator = Fw.component.models().form;
        cartUtils = Fw.component.models().cartUtils;
		hubspot = Fw.component.models().hubspot;
        formCtn = $('.event-signup');
        pageEventId = formCtn.attr('data-eventid');

        participantsCtn = $('.event-signup__participants');
        participantsQuantity = participantsCtn.find('.event-signup__participant.signed-up').length;
        noParticipantsActions = $('.event-signup__add-participant-btns');
        validateParticipantsBtn = $('.event-signup__validate-btn_participants');
        addParticipantBtn = $('.event-signup__add-participant-btn');

        $('.payment-step__validate-btn').click(goToNextStep);
        $('.payment-step__ignore-check').change(goToNextStep);
        
        addParticipantBtn.click(addParticipantInputs);
        addParticipantBtn.each(function(i, el) {
            if ($(el).hasClass('js-activate-add-participant')) {
                addParticipantInputs.call(el);
            }
        });
        
        formCtn.on('click', '.event-signup__remove-participant-btn', function () {
            var participant = $(this).closest('.event-signup__participant');
            removeParticipant(pageEventId, participant.attr('data-firstname'), participant.attr('data-lastname'));
        });
        formCtn.on('focusout', '.event-signup__participant .form-input', handleParticipant);
        formCtn.on('change', '.event-signup__participant .form-input', function () {
            changeOccured = true;
        });
        formCtn.on('keyup', '.event-signup__participant .firstName,.event-signup__participant .lastName', updateParticipantNameData);
        formCtn.on('change', '.event-signup__participant .firstName,.event-signup__participant .lastName', updateParticipantNameData);

        $('.event-signup__confirm-order-btn').click(goToPayment);
        //Q: Why clicking on the section enable the disabled Valider/Confirm button?
        //A: Because the validation can be reactivated then the user scroll back to click on the section, e.g. adding an item to cart
        $('.payment-step__section').click(enableValidateBtn);
        $('.cart-coaching-item__add-to-cart-btn').click(function () {
            updateCartCoachingProduct($(this), participantsQuantity);
        });
        $('.cart-coaching-item__remove-from-cart-btn').click(function () {
            updateCartCoachingProduct($(this), 0);
        });
        
        $('.event-promo-signup__form').on('submit', submitEventPromoSignupForm);
    });

    Fw.component.export('eventSignup', {
        updateRecap: updateRecap,
        removeParticipant: removeParticipant,
        resetSignupBtnsState: resetSignupBtnsState
    });
})(jQuery);
